export const metaModel = ({ currentPage = 1, perPage = 10 }) => ({
  per_page: perPage,
  page: currentPage
})
